/* ============================================================
   Reveal
   The New Savant — Mint Lane Studio

   Adds .is-revealed to anything marked [data-tns-reveal] or
   [data-tns-stagger] as it enters the viewport, once.

   The attributes are namespaced deliberately: a bare
   [data-reveal] collided with a section that already used that
   name for its own animation.

   Two rules it follows:

   1. It marks <html> before hiding anything, so the hiding CSS
      only ever applies when this script is running.
   2. Anything already on screen at load is revealed immediately
      with no transition, so the first paint is never animated.
      That keeps the hero and anything above the fold out of it.
   ============================================================ */

(function () {
  'use strict';

  if (window.__tnsReveal) return;
  window.__tnsReveal = true;

  var root = document.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!('IntersectionObserver' in window) || reduced) {
    // Everything stays visible; the CSS never engages.
    return;
  }

  root.classList.add('tns-reveal-ready');

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    },
    {
      // Fires a little before the element is fully in view, so the
      // movement finishes about when it reaches reading position.
      rootMargin: '0px 0px -12% 0px',
      threshold: 0.08
    }
  );

  function prepare(scope) {
    var targets = (scope || document).querySelectorAll(
      '[data-tns-reveal], [data-tns-stagger]'
    );

    for (var i = 0; i < targets.length; i++) {
      var el = targets[i];
      if (el.dataset.tnsReveal === 'true') continue;
      el.dataset.tnsReveal = 'true';

      // Index the children of a staggered group.
      if (el.hasAttribute('data-tns-stagger')) {
        var kids = el.children;
        for (var k = 0; k < kids.length; k++) {
          kids[k].style.setProperty('--tns-i', k);
        }
      }

      // Already on screen: show it now, without animating in.
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        var prev = el.style.transition;
        el.style.transition = 'none';
        el.classList.add('is-revealed');
        // Force the change to apply before the transition returns.
        void el.offsetWidth;
        el.style.transition = prev;
        continue;
      }

      observer.observe(el);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      prepare();
    });
  } else {
    prepare();
  }

  // Theme editor: pick up sections as they are added or redrawn.
  document.addEventListener('shopify:section:load', function (e) {
    prepare(e.target);
  });
})();